import { render, staticRenderFns } from "./ProductAlternativeSkeleton.vue?vue&type=template&id=526692b6&"
import script from "./ProductAlternativeSkeleton.vue?vue&type=script&lang=js&"
export * from "./ProductAlternativeSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports